/* eslint-disable */
export default {
  unknown: '未知',
  anonymous: '匿名',
  activeCall: '進行中的通話',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
